import Logger from "../lib/logger";

class ThemeHeader {

	NAME = 'ThemeHeader';

	constructor(dom, cartService) {
		this.dom = dom;
		this.cartService = cartService;

		this.htmlNoScrollClass = `no-scroll`;

		// Cart
		this.cartToggleDoms = this.dom.querySelectorAll(`[data-theme-header-cart-toggle]`);
		this.cartQuantityDoms = this.dom.querySelectorAll(`[data-theme-header-cart-quantity]`);

		// All Drawers
		this.themeHeaderDrawersAreExpanded = false;
		this.themeHeaderDrawerDoms = this.dom.querySelectorAll(`[data-theme-header-drawer]`);
		this.themeHeaderDrawerToggleDoms = this.dom.querySelectorAll(`[data-theme-header-drawer-toggle]`);

		// Desktop Support
		this.themeHeaderSupportPaneActiveClass = `theme-header-desktop__support-pane--active`;
		this.themeHeaderSupportPaneDom = this.dom.querySelector(`[data-theme-header-support-pane]`);
		this.themeHeaderSupportToggleDom = this.dom.querySelector(`[data-theme-header-support-toggle]`);

		// Mobile Drawer
		this.themeMobileDrawerMainPaneHiddenClass = `theme-header-drawer-mobile__drawer-pane--hidden`;
		this.themeMobileDrawerSidePaneActiveClass = `theme-header-drawer-mobile__drawer-pane--active`;
		this.themeMobileDrawerSidePaneDoms = this.dom.querySelectorAll(`[data-theme-header-drawer-mobile-pane]`);
		this.themeMobileDrawerSideToggleDoms = this.dom.querySelectorAll(`[data-theme-header-drawer-mobile-toggle-side]`);
		this.themeMobileDrawerShowMainPaneDoms = this.dom.querySelectorAll(`[data-theme-header-drawer-mobile-pane-show-main-button]`);

		// Search
		this.searchDialogActiveClass = `theme-header-search--active`;
		this.themeSearchDialogDom = this.dom.querySelector(`[data-theme-header-search]`);
		this.themeSearchDialogToggleButtonDoms = this.dom.querySelectorAll(`[data-theme-header-search-toggle]`);
		this.searchInput = this.themeSearchDialogDom.querySelector('.search__input');
	}

	/**
	 *  init --- Initialize the product or webpage
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initCartToggles();
		this.initSearchDialog();
		this.initSupportPane();
		this.initToggles();
		this.initNavAdjustment();
	}

	/**
	 * closeSearchDialog - Close the search dialog
	 */
	closeSearchDialog() {
		Logger.info(`${this.NAME} > closeSearchDialog`);

		this.themeSearchDialogDom.classList.remove(this.searchDialogActiveClass);
	}

	/**
	 * closeSupportPane - Close the support pane
	 */
	closeSupportPane() {
		Logger.info(`${this.NAME} > closeSupportPane`);
		this.themeHeaderSupportPaneDom.classList.remove(this.themeHeaderSupportPaneActiveClass);
	}

	/**
	 * initCartToggles - Initialize the cart toggle
	 */
	initCartToggles() {
		Logger.info(`${this.NAME} > initCartToggles`);

		const self = this;

		this.cartToggleDoms.forEach(cartToggle => {
			cartToggle.addEventListener('click', (e) => {
				e.preventDefault();
				let event = new Event("mini-cart.open");
				document.dispatchEvent(event);
			});
		});

		// Listen for cart.get
		this.cartService.on(`cart.get`, (cartJson) => {
			self.cartQuantityDoms.forEach(quantity => {
				quantity.innerHTML = cartJson.item_count ? cartJson.item_count : ``;
			});
		});

		// Listen for cart.updated
		this.cartService.on(`cart.updated`, () => {
			const cartJson = self.cartService.get(true);
			self.cartQuantityDoms.forEach(quantity => {
				quantity.innerHTML = cartJson.item_count ? cartJson.item_count : ``;
			});
		});
	}

	/**
	 * initSearchDialog - Initialize the search dialog
	 */
	initSearchDialog() {
		Logger.info(`${this.NAME} > initSearchDialog`);

		const self = this;

		this.themeSearchDialogToggleButtonDoms.forEach(toggle => {
			toggle.addEventListener(`click`, e => {
				e.preventDefault();
				self.toggleSearchDialog();
			});
		});

		// Listen for events to open the search
		document.addEventListener(`header.search.open`, function (event) {
			self.openSearchDialog();
		});

		// Listen for events to close the search
		document.addEventListener(`header.search.close`, function (event) {
			self.closeSearchDialog();
		});
	}

	/**
	 * initSupportPane - Initialize the support pane
	 */
	initSupportPane() {
		Logger.info(`${this.NAME} > initSupportPane`);

		const self = this;

		this.themeHeaderSupportToggleDom?.addEventListener(`click`, e => {
			e.preventDefault();
			self.requestCloseMiniCart();
			self.closeSearchDialog();
			self.closeDrawers();
			self.themeHeaderSupportPaneDom.classList.toggle(self.themeHeaderSupportPaneActiveClass);
		});

		// Listen for events to open the search
		document.addEventListener(`header.support.open`, function (event) {
			self.openSupportPane();
		});

		// Listen for events to close the search
		document.addEventListener(`header.support.close`, function (event) {
			self.closeSupportPane();
		});

	}

	/**
	 * initToggles - Initialize the toggles that should open drawers
	 */
	initToggles() {
		Logger.info(`${this.NAME} > initToggles`);

		const self = this;



		// Listen for events to close the search
		document.addEventListener(`header.drawers.close`, function (event) {
			self.closeDrawers();
		});

		// Initialize toggles to open the main drawers
		// In Desktop: this opens the drawer when the Shop link is clicked
		// In Mobile: this opens the mobile menu when the hamburger is clicked
		this.themeHeaderDrawerToggleDoms.forEach(toggle => {
			toggle.addEventListener(`click`, e => {
				e.preventDefault();
				self.toggleDrawers();
			});
		});

		/**
		 * MOBILE TOGGLES
		 */

		// Initialize the toggles that open the side drawers in mobile only
		this.themeMobileDrawerSideToggleDoms.forEach(toggle => {
			toggle.addEventListener(`click`, e => {
				e.preventDefault();
				const name = toggle.getAttribute(`data-theme-header-drawer-mobile-toggle-side`);
				self.openMobileSideDrawer(name);
			});
		});


		// Initializes the toggles that will hide all side panes and go back to the main pane,
		// in mobile only
		this.themeMobileDrawerShowMainPaneDoms.forEach(toggle => {
			toggle.addEventListener(`click`, e => {
				e.preventDefault();
				self.closeAllSidePanes();
			});
		});

	}

	/**
	 * closeDrawers - Close the drawers
	 */
	closeDrawers() {
		Logger.info(`${this.NAME} > closeDrawers`);

		this.themeHeaderDrawerDoms.forEach(drawer => {
			drawer.setAttribute('data-expanded', false);
		});

		this.themeHeaderDrawerToggleDoms.forEach(toggle => {
			toggle.setAttribute('aria-expanded', false);
		});
		this.themeHeaderDrawersAreExpanded = false;

		document.documentElement.classList.remove(this.htmlNoScrollClass);
		document.body.classList.remove(this.htmlNoScrollClass);
	}

	/**
	 * closeAllSidePanes - Close all the side panes in the mo
	 */
	closeAllSidePanes() {
		Logger.info(`${this.NAME} > closeAllSidePanes`);
		this.themeMobileDrawerSidePaneDoms.forEach(pane => {
			pane.classList.remove(this.themeMobileDrawerSidePaneActiveClass);
		});
	}

	/**
	 * requestCloseMiniCart - Send a request to close the mini cart
	 */
	requestCloseMiniCart() {
		Logger.info(`${this.NAME} > closeAllSidePanes`);
		let event = new Event("mini-cart.close");
		document.dispatchEvent(event);
	}

	/**
	 * openDrawers - Open the drawers
	 */
	openDrawers() {
		Logger.info(`${this.NAME} > openDrawers`);

		this.closeSearchDialog();
		this.closeSupportPane();

		this.themeHeaderDrawerDoms.forEach(drawer => {
			drawer.setAttribute('data-expanded', true);
		});

		this.themeHeaderDrawerToggleDoms.forEach(toggle => {
			toggle.setAttribute('aria-expanded', true);
		});
		this.themeHeaderDrawersAreExpanded = true;

		document.documentElement.classList.add(this.htmlNoScrollClass);
		document.body.classList.add(this.htmlNoScrollClass);
	}

	/**
	 * openMobileSideDrawer - Open a side drawer pane in mobile only
	 */
	openMobileSideDrawer(name) {
		Logger.info(`${this.NAME} > openMobileSideDrawer > ${name}`);

		this.themeMobileDrawerSidePaneDoms.forEach(pane => {
			const paneName = pane.getAttribute(`data-theme-header-drawer-mobile-pane`);
			if (paneName == name) {
				pane.classList.add(this.themeMobileDrawerSidePaneActiveClass);
			} else {
				pane.classList.remove(this.themeMobileDrawerSidePaneActiveClass);
			}
		});
	}

	/**
	 * openSearchDialog - Open the search dialog
	 */
	openSearchDialog() {
		Logger.info(`${this.NAME} > openSearchDialog`);

		this.closeSupportPane();

		this.themeSearchDialogDom.classList.add(this.searchDialogActiveClass);
	}

	/**
	 * openSupportPane - Open the search dialog
	 */
	openSupportPane() {
		Logger.info(`${this.NAME} > openSupportPane`);

		this.closeSearchDialog();

		this.themeHeaderSupportPaneDom.classList.add(this.themeHeaderSupportPaneActiveClass);

		this.requestCloseMiniCart();
	}

	/**
	 * toggleDrawers - Toggle the drawers
	 */
	toggleDrawers() {
		Logger.info(`${this.NAME} > toggleDrawers`);
		if (this.themeHeaderDrawersAreExpanded) {
			this.closeDrawers();
		} else {
			this.openDrawers();
			let event = new Event("mini-cart.close");
			document.dispatchEvent(event);
		}

		this.requestCloseMiniCart();
	}

	/**
	 * toggleSearchDialog - Toggle the search dialog
	 */
	toggleSearchDialog() {
		Logger.info(`${this.NAME} > toggleSearchDialog`);

		this.closeSupportPane();
		this.themeSearchDialogDom.classList.toggle(this.searchDialogActiveClass);
		if (this.themeSearchDialogDom.classList.contains(this.searchDialogActiveClass)) {
			setTimeout(() => {
				this.searchInput.focus();
			}, 100);
		}
		this.requestCloseMiniCart();
	}

	initNavAdjustment() {
		Logger.info(`${this.NAME} > adjustNavBar`);

		setTimeout(() => {
			let announcementBar = document.querySelector('.ssbar');
			if (announcementBar) {
				this.adjustNavBar(announcementBar);
				var self = this;

				window.addEventListener('resize', function (event) {
					self.adjustNavBar(announcementBar);
				});

				window.addEventListener('scroll', function (event) {
					self.adjustNavBar(announcementBar);
				});
			}
		}, 2000);
	}

	/**
	 * adjustNavBar - Adjust position of header nav bar to accommodate Easy Announce Bar
	 */
	adjustNavBar(announcementBar) {
		setTimeout(() => {
			let themeHeader = document.querySelector('#theme-header');
			let mainContent = document.querySelector('.theme-main');

			let position = window.getComputedStyle(announcementBar, null).position;
			let top = window.getComputedStyle(announcementBar, null).top;
			let height = announcementBar.offsetHeight;
			let scrollPosition = window.scrollY;
			let mainOffset = window.innerWidth >= 1024 ? 60 : 49;

			if (position == 'fixed' && top == '0px') {
				themeHeader.style.marginTop = height + 'px';
				mainContent.style.paddingTop = height + mainOffset + 'px';
			} else if (position == 'relative' && scrollPosition < height) {
				height -= scrollPosition;
				themeHeader.style.marginTop = height + 'px';
			} else if (position == 'relative' && scrollPosition >= height) {
				themeHeader.style.marginTop = '0px';
			}
		}, 100);
	}
}

export default ThemeHeader;
